import React from "react";

import Waiting from "../../images/waiting.svg";

const Loading = () => <img width="318px" src={Waiting} alt="Loading" />;

export default Loading;
